<template>
	<div class="content-section-b">
		<div class="container ">
			<div class="row">
				<div class="col-lg-12">
					<h2 class="section-heading">Have a Project?</h2>
					<a href="mailto:ritesh.parmar1096@gmail.com"
						><button
							id="button"
							class="animated infinite pulse btn btn-success btn-lg mt-4 mx-5"
						>
							<i class="icon fas fa-hands-helping" aria-hidden="true"></i>
							Hire Me
						</button></a
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
.content-section-b {
	padding: 50px 0;
	background: linear-gradient(
		rgba(18%, 67%, 98%, 0.75),
		rgba(18%, 67%, 98%, 0.85)
	);
	text-align: center;
	color: white;
}
#button {
	color: white;
	font-size: 24px;
	margin-top: 30px;
	border: solid 6px white;
	background: #65ce9b;
	padding: 15px;
	text-transform: uppercase;
	font-weight: 500;
}
</style>
